import { Link } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";

export function CtaSection() {
  return (
    <section className="py-20 bg-earth-green local-pattern">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-cream">
        <div className="space-y-8">
          <h2 className="text-3xl sm:text-4xl font-bold handwriting">
            準備開始您的數位轉型之旅了嗎？
          </h2>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            就像品嚐一碗用心熬煮的麻薏湯，讓我們陪您慢慢品味數位轉型的每一個步驟
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to={ROUTES.LOGIN}
              className="inline-flex items-center justify-center px-8 py-4 bg-cream text-earth-green rounded-full font-semibold hover:bg-white transition-colors soft-hover warm-shadow"
            >
              <i className="fas fa-coffee mr-2"></i>
              來喝杯茶聊聊
            </Link>
            <a
              href="#contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-warm-beige/20 backdrop-blur-sm text-cream border-2 border-cream/30 rounded-full font-semibold hover:bg-cream/20 transition-colors"
            >
              <i className="fas fa-phone mr-2"></i>
              先了解看看
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
